import type {
    MessageScrollerSnapshotType,
    MessageScrollerStoreType
} from "./type";

export const createMessageScrollerStore = (): MessageScrollerStoreType => {
    const listeners = new Set<() => void>();

    let snapshot: MessageScrollerSnapshotType = {
        currentAnchorId: null,
        isFocusVisible: false,
        isLoadingOlder: false,
        highlightedId: null,
        isFadeStart: false,
        newMessageCount: 0,
        isMeasured: false,
        isFadeEnd: false,
        isAtStart: true,
        spacerHeight: 0,
        isAtEnd: true
    };

    return {
        update: (patch) => {
            const keys = Object.keys(patch) as Array<keyof MessageScrollerSnapshotType>;

            if(keys.every((key) => snapshot[key] === patch[key])) {
                return;
            }

            snapshot = {
                ...snapshot,
                ...patch
            };

            listeners.forEach((listener) => {
                listener();
            });
        },
        subscribe: (listener) => {
            listeners.add(listener);

            return () => {
                listeners.delete(listener);
            };
        },
        getSnapshot: () => snapshot
    };
};
